import { fgWmsSotFilterEntries } from "@redotech/redo-fulfillment-operations-common/views/fulfillment/fg-filter-catalog";
import AlertTriangleIcon from "@redotech/redo-icons/alert-triangle.svg";
import { BooleanFilterOperator } from "@redotech/redo-views-common/advanced-filters/boolean-filter";
import { BooleanTableFilter } from "@redotech/redo-web/advanced-filters/advanced-filter";

const entry = fgWmsSotFilterEntries.noInventoryInWarehouse;

export const NoInventoryInWarehouseFilter: BooleanTableFilter = {
  type: entry.type,
  data: {
    name: entry.name,
    type: entry.type,
    value: null,
    operator: BooleanFilterOperator.IS,
  },
  Icon: AlertTriangleIcon,
  displayName: entry.displayName,
  label: "Warehouse",
  boolDisplay: { falseDisplay: "stocked", trueDisplay: "out of stock" },
};
